import { gsap } from 'gsap';

import './hover-work-effect.scss';


export class HoverWorkEffect {

	DOM: any;
	positionElement: any;

	getMousePos = (e: MouseEvent) => {
		let posx = 0;
		let posy = 0;
		if (!e) {
			// @ts-ignore
			e = window.event;
		}

		if (e.pageX || e.pageY) {
			posx = e.pageX;
			posy = e.pageY;
		} else if (e.clientX || e.clientY) {
			posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
			posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
		}

		return { x : posx, y : posy }
	}

	mouseEnterFn: Function;
	mouseMoveFn: Function;
	mouseLeaveFn: Function;

	tl: any;


	constructor(el: HTMLElement) {

		this.DOM = { el: el };
		this.DOM.reveal = document.createElement('div');
		this.DOM.reveal.className = 'hover-reveal';
		this.DOM.reveal.innerHTML = `<div class="hover-reveal__inner"><div class="hover-reveal__img" style="background-image:url(${this.DOM.el.dataset.img})"></div></div>`;
		this.DOM.el.appendChild(this.DOM.reveal);

		this.DOM.revealInner = this.DOM.reveal.querySelector('.hover-reveal__inner');
		this.DOM.revealInner.style.overflow = 'hidden';
		this.DOM.revealImg = this.DOM.revealInner.querySelector('.hover-reveal__img');

		this.initEvents();

	}


	initEvents() {

		this.positionElement = (ev: MouseEvent) => {
			const mousePos = this.getMousePos(ev);
			const docScrolls = {
				left : document.body.scrollLeft + document.documentElement.scrollLeft,
				top : document.body.scrollTop + document.documentElement.scrollTop
			};

			this.DOM.reveal.style.top = `${mousePos.y-docScrolls.top}px`;
			this.DOM.reveal.style.left = `${mousePos.x+20-docScrolls.left}px`;
		};

		this.mouseEnterFn = (ev: MouseEvent) => {
			this.positionElement(ev);
			this.showImage();
		};

		this.mouseMoveFn = (ev: MouseEvent) => requestAnimationFrame(() => {
			this.positionElement(ev);
		});

		this.mouseLeaveFn = () => {
			this.hideImage();
		};

		this.DOM.el.addEventListener('mouseenter', this.mouseEnterFn);
		this.DOM.el.addEventListener('mousemove', this.mouseMoveFn);
		this.DOM.el.addEventListener('mouseleave', this.mouseLeaveFn);

	}


	showImage() {
		gsap.killTweensOf(this.DOM.revealInner);
		gsap.killTweensOf(this.DOM.revealImg);

		this.tl = gsap.timeline({
						onStart: () => {
							this.DOM.reveal.style.opacity = 1;
							gsap.set( this.DOM.el, { zIndex: 1000 })
						}
					})
					.add('begin')
					.add(gsap.to( this.DOM.revealInner, {
						duration: .4,
						ease: "power4.out",
						startAt: {x: '-100%', y: '-100%'},
						x: '0%',
						y: '0%',
					}), 'begin')
					.add( gsap.to(this.DOM.revealImg, {
						duration: .4,
						ease: "power4.out",
						startAt: {x: '100%', y: '100%'},
						x: '0%',
						y: '0%'
					}), 'begin' );
	}


	hideImage() {
		gsap.killTweensOf(this.DOM.revealInner);
		gsap.killTweensOf(this.DOM.revealImg);

		this.tl = gsap.timeline({
				onStart: () => {
					gsap.set( this.DOM.el, { zIndex: 999 })
				},
				onComplete: () => {
					gsap.set( this.DOM.el, { zIndex: '' })
					gsap.set( this.DOM.reveal, { opacity: 0 })

				}
			})
			.add('begin')
			.add( gsap.to(this.DOM.revealInner, {
				duration: .3,
				ease: "power4.out",
				x: '100%',
				y: '100%'
			}), 'begin' )
			.add( gsap.to(this.DOM.revealImg, {
				duration: .3,
				ease: "power4.out",
				x: '-100%',
				y: '-100%'
			}), 'begin' );
	}

}